import MainWrapper from "@/components/base/MainWrapper";
import styled from "styled-components";
import {breakpoints} from "@/styles/sizes";
import {CkEditorPagesContentWrapper} from "@/styles/GlobalStyles";
import {fetchPageData} from "@/services/dataFetcher";

const MobileContentWrapper = styled.div`
  @media only screen and (${breakpoints.mobile}) {
    padding: 20px;
  }
`
const Terms = ({data, isMobile}) => {

  return <MainWrapper
      regionsData={data?.data?.regions}
      headerData={data?.data?.header}
      footerData={data?.data?.footer}
      socialLinks={data?.data?.socialLinks}
      searchOptions={data?.data?.searchOptions}
      isMobileDefault={isMobile}
  >

    <MobileContentWrapper>
      <CkEditorPagesContentWrapper className={'container_small'} dangerouslySetInnerHTML={{__html: data?.data?.page?.data?.content}}/>
    </MobileContentWrapper>


  </MainWrapper>
      ;
};


export const getServerSideProps = async (context) => {
  return await fetchPageData("getTermsData",context);
};
export default Terms;
